import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actions?: { label: string; path: string; external?: boolean; primary?: boolean }[];
}

export default function EmptyState({ icon = 'ri-inbox-line', title, description, actions }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 md:py-20 px-6">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-background-100 flex items-center justify-center mb-6">
        <i className={`${icon} text-foreground-300 text-2xl md:text-3xl`}></i>
      </div>
      <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-800 mb-3 tracking-tight">
        {title}
      </h3>
      {description && (
        <p className="text-base text-foreground-500 leading-relaxed max-w-md text-center mb-8">
          {description}
        </p>
      )}
      {actions && actions.length > 0 && (
        <div className="flex flex-col sm:flex-row items-center gap-3">
          {actions.map((action, idx) =>
            action.external ? (
              <a
                key={idx}
                href={action.path}
                target="_blank"
                rel="noopener noreferrer"
                className={`whitespace-nowrap px-6 py-2.5 rounded-full text-[15px] font-medium transition-colors cursor-pointer tracking-wide ${
                  action.primary
                    ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                    : 'border border-foreground-200 text-foreground-700 hover:border-foreground-400 hover:bg-background-100'
                }`}
              >
                {action.label}
                <i className="ri-external-link-line ml-1.5 text-[13px]"></i>
              </a>
            ) : (
              <Link
                key={idx}
                to={action.path}
                className={`whitespace-nowrap px-6 py-2.5 rounded-full text-[15px] font-medium transition-colors cursor-pointer tracking-wide ${
                  action.primary
                    ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                    : 'border border-foreground-200 text-foreground-700 hover:border-foreground-400 hover:bg-background-100'
                }`}
              >
                {action.label}
                <i className="ri-arrow-right-line ml-1.5 text-[13px]"></i>
              </Link>
            )
          )}
        </div>
      )}
    </div>
  );
}